// User Types
export const USER_TYPES = {
  CLIENT: 'client',
  CLIENT_USER: 'client_child_user',
  ADMIN: 'admin',
};

// User Status
export const USER_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
  SUSPENDED: 2,
  PENDING: 3,
};

// Search Types
export const SEARCH_TYPES = {
  TM_NUMBER: 'tm_number',
  TM_NUMBERS: 'tm_numbers',
  TM_NAME: 'tm_name',
  IMAGE: 'image',
  PROPRIETOR: 'proprietor',
  ATTORNEY: 'attorney',
  WATCH: 'watch',
};

// Search Type Labels
export const SEARCH_TYPE_LABELS = {
  [SEARCH_TYPES.TM_NUMBER]: 'Trademark Number',
  [SEARCH_TYPES.TM_NUMBERS]: 'Multiple Trademark Numbers',
  [SEARCH_TYPES.TM_NAME]: 'Trademark Name',
  [SEARCH_TYPES.IMAGE]: 'Trademark Image',
  [SEARCH_TYPES.PROPRIETOR]: 'Proprietor',
  [SEARCH_TYPES.ATTORNEY]: 'Attorney',
  [SEARCH_TYPES.WATCH]: 'Watch',
};

// Match Types
export const MATCH_TYPES = {
  EXACT: 'exact',
  CONTAINS: 'contains',
  STARTS_WITH: 'starts_with',
  ENDS_WITH: 'ends_with',
  FUZZY: 'fuzzy',
};

// Trademark Status
export const TRADEMARK_STATUS = {
  APPLIED: 1,
  REGISTERED: 2,
  OPPOSED: 3,
  ABANDONED: 4,
  EXPIRED: 5,
  RENEWED: 6,
};

// Report Formats
export const REPORT_FORMATS = {
  PDF: 'pdf',
  EXCEL: 'excel',
  CSV: 'csv',
};

// View Types
export const VIEW_TYPES = {
  CARD: 'card',
  TABLE: 'table',
  LIST: 'list',
};

// Link Behaviors
export const LINK_BEHAVIORS = {
  SAME_WINDOW: 'same_window',
  NEW_TAB: 'new_tab',
  NEW_WINDOW: 'new_window',
};

// Sort Orders
export const SORT_ORDERS = {
  ASC: 'asc',
  DESC: 'desc',
};

// Sort Fields
export const SORT_FIELDS = {
  RELEVANCE: 'relevance',
  DATE: 'date',
  NAME: 'name',
  STATUS: 'status',
  CLASS: 'class',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
};

// File Types
export const FILE_TYPES = {
  IMAGE: 'image',
  DOCUMENT: 'document',
  REPORT: 'report',
};

// Allowed File Extensions
export const ALLOWED_EXTENSIONS = {
  IMAGES: ['.jpg', '.jpeg', '.png', '.gif', '.webp'],
  DOCUMENTS: ['.pdf', '.doc', '.docx'],
  REPORTS: ['.pdf', '.xlsx', '.csv'],
};

// Theme Colors
export const THEME_COLORS = {
  PRIMARY: {
    50: '#eff6ff',
    100: '#dbeafe',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
    900: '#1e3a8a',
  },
  SUCCESS: {
    50: '#f0fdf4',
    100: '#dcfce7',
    500: '#22c55e',
    600: '#16a34a',
    700: '#15803d',
  },
  WARNING: {
    50: '#fffbeb',
    100: '#fef3c7',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
  },
  ERROR: {
    50: '#fef2f2',
    100: '#fee2e2',
    500: '#ef4444',
    600: '#dc2626',
    700: '#b91c1c',
  },
};

// Navigation Routes
export const ROUTES = {
  // Public Routes
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Private Routes
  DASHBOARD: '/dashboard',
  Applying_Trademark: '/applyingTrademark',
  SEARCH: '/search',
  SEARCH_HISTORY: '/search/history',
  SEARCH_STATISTICS: '/search/statistics',
  
 DESIGN_SEARCH: "/design-search",
 PATENT_SEARCH: "/patent-search",
INTERNATIONAL_SEARCH: "/international-search",
  // TM Manager Routes
  YOUR_TRADEMARK_DASHBOARD: '/tm/your-trademark/dashboard',
  YOUR_DEADLINES_DASHBOARD: '/tm/your-trademark/deadlines',
  YOUR_ALL_TRADEMARK: '/tm/your-trademark/all',
  Portfolio_Deadline_Management: '/tm/portfolio-deadline-management',
  Portfolio_Trademarks: '/tm/portfolio-trademarks/all',
  MANAGE_TRADEMARKS: '/tm/manage',


  
  OPPONENT_TRADEMARK_DASHBOARD: '/tm/opponent/dashboard',
  OPPONENT_DEADLINES_DASHBOARD: '/tm/opponent/deadlines',
  OPPONENT_ALL_TRADEMARK: '/tm/opponent/all',
  PORTFOLIO: '/tm/portfolio',
  
//watch manager

Application_Level: '/applicationLevel',
Examination_Report: '/examinationReport',
Application_Status: '/applicationStatus',
Proprietor_Status: '/proprietorStatus',
Journal_Level :'/JournalLevel',
Single_Click_Report :'/PremiumFile',
Focus_Word :'/focusWord',
Change_Tracker :'/changeTracker',
Status_Change_Tracker: '/statusChangeTracker',
Document_Change_Tracker: '/documentChangeTracker',
Attorney_Change_Tracker: '/attorneyChangeTracker',
Upload_Document_Tracker: '/uploadedDocumentTracker',


Image_Converter:'utility/image-converter',

// manage customer page
Manage_Customer: '/manageCustomer',
// Premium Features
Astro_Mark: '/astroMark',
Astro_Mark_Report: '/astroMarkReport',
Notification_Analytics:'/notificationAnalytics',
//All Reports
Search_Report: '/SearchReport',

  // User Management
  MANAGE_TAGS: '/manageTags',
  PROFILE: '/profile',
  PREFERENCES: '/preferences',
  USERS: '/client-admin-panel/add-edit-users',
  USER_CREATE: '/users/create',
  USER_EDIT: '/users/:id/edit',

  // Client Admin Panel
  ADMIN_PANEL: '/client-admin-panel',
  ADMIN_PANEL_USERS: '/client-admin-panel/users',
  ADMIN_PANEL_ROLES: '/client-admin-panel/roles',
  ADMIN_PANEL_TEAMS: '/client-admin-panel/teams',
  ADMIN_PANEL_HIERARCHY: '/client-admin-panel/hierarchy',

  // Legal Drafting
  LEGAL_DRAFTING:       '/legal-drafting',
  LEGAL_DRAFTING_CASES: '/legal-drafting/cases',
  BRAND_GENERATOR:           '/brand-generator',
  TRADEMARK_PREDICTOR:       '/trademark-predictor',
  OPPONENT_STRENGTH:    '/opponent-strength',

  // Task Management
  TASKS: '/tasks',
  TASK_REMINDERS: '/tasks/reminders',

  // Reports & Documents
  REPORTS: '/reports',
  REPORT_CREATE: '/reports/create',
  REPORT_VIEW: '/reports/:id',
  DOCUMENTS: '/documents',
  NOTES: '/notes',

  // Settings
  SETTINGS: '/settings',
  BILLING: '/billing',
  LICENSE: '/license',
  WHATSAPP_SETUP: '/whatsapp-setup',
  EMAIL_SETTINGS:'/email-settings',
  CLIENT_EMAIL_TEMPLATE:'/client-email-template',
  //UNAUTHORIZED
 UNAUTHORIZED: '/403',
  // Not Found
  NOT_FOUND: '/404',
};

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  USER_DATA: 'userData',
  REMEMBER_ME: 'rememberMe',
  THEME: 'theme',
  LANGUAGE: 'language',
  SIDEBAR_COLLAPSED: 'sidebarCollapsed',
  SEARCH_PREFERENCES: 'searchPreferences',
  RECENT_SEARCHES: 'recentSearches',
};

// Default Values
export const DEFAULTS = {
  PAGE_SIZE: 20,
  DEBOUNCE_MS: 300,
  TOAST_DURATION: 5000,
  SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutes
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  SIMILARITY_THRESHOLD: 80,
  RESULTS_PER_PAGE: 20,
};

// Validation Rules
export const VALIDATION = {
  PASSWORD: {
    MIN_LENGTH: 8,
    REQUIRE_UPPERCASE: true,
    REQUIRE_LOWERCASE: true,
    REQUIRE_NUMBERS: true,
    REQUIRE_SPECIAL: true,
  },
  EMAIL: {
    PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },
  PHONE: {
    PATTERN: /^[\+]?[1-9][\d]{0,15}$/,
  },
  NAME: {
    MIN_LENGTH: 2,
    MAX_LENGTH: 50,
  },
  COMPANY: {
    MIN_LENGTH: 2,
    MAX_LENGTH: 100,
  },
  NOTE: {
    MAX_LENGTH: 1000,
  },
  REPORT_NAME: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 100,
  },
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  SERVER_ERROR: 'Server error. Please try again later.',
  AUTHENTICATION_FAILED: 'Authentication failed. Please login again.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  FILE_TOO_LARGE: 'File size exceeds the maximum limit.',
  INVALID_FILE_TYPE: 'Invalid file type.',
  QUOTA_EXCEEDED: 'Search quota exceeded.',
  SESSION_EXPIRED: 'Session expired. Please login again.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Login successful!',
  LOGOUT_SUCCESS: 'Logout successful!',
  PROFILE_UPDATED: 'Profile updated successfully!',
  PASSWORD_CHANGED: 'Password changed successfully!',
  USER_CREATED: 'User created successfully!',
  USER_UPDATED: 'User updated successfully!',
  USER_DELETED: 'User deleted successfully!',
  REPORT_GENERATED: 'Report generated successfully!',
  NOTE_SAVED: 'Note saved successfully!',
  PREFERENCES_SAVED: 'Preferences saved successfully!',
};

// Countries
export const COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'AU', name: 'Australia' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'IT', name: 'Italy' },
  { code: 'ES', name: 'Spain' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'SE', name: 'Sweden' },
  { code: 'NO', name: 'Norway' },
  { code: 'DK', name: 'Denmark' },
  { code: 'FI', name: 'Finland' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'AT', name: 'Austria' },
  { code: 'BE', name: 'Belgium' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'IE', name: 'Ireland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'GR', name: 'Greece' },
];

// Nice Classification Classes
export const TRADEMARK_CLASSES = [
  { id: 1, name: 'Chemicals', label: 'Class 1' },
  { id: 2, name: 'Paints', label: 'Class 2' },
  { id: 3, name: 'Cosmetics and cleaning preparations', label: 'Class 3' },
  { id: 4, name: 'Lubricants and fuels', label: 'Class 4' },
  { id: 5, name: 'Pharmaceuticals', label: 'Class 5' },
  { id: 6, name: 'Metal goods', label: 'Class 6' },
  { id: 7, name: 'Machinery', label: 'Class 7' },
  { id: 8, name: 'Hand tools', label: 'Class 8' },
  { id: 9, name: 'Electrical and scientific apparatus', label: 'Class 9' },
  { id: 10, name: 'Medical apparatus', label: 'Class 10' },
  { id: 11, name: 'Environmental control apparatus', label: 'Class 11' },
  { id: 12, name: 'Vehicles', label: 'Class 12' },
  { id: 13, name: 'Firearms', label: 'Class 13' },
  { id: 14, name: 'Jewelry', label: 'Class 14' },
  { id: 15, name: 'Musical instruments', label: 'Class 15' },
  { id: 16, name: 'Paper goods and printed matter', label: 'Class 16' },
  { id: 17, name: 'Rubber goods', label: 'Class 17' },
  { id: 18, name: 'Leather goods', label: 'Class 18' },
  { id: 19, name: 'Nonmetallic building materials', label: 'Class 19' },
  { id: 20, name: 'Furniture and articles not otherwise classified', label: 'Class 20' },
  { id: 21, name: 'Housewares and glass', label: 'Class 21' },
  { id: 22, name: 'Cordage and fibers', label: 'Class 22' },
  { id: 23, name: 'Yarns and threads', label: 'Class 23' },
  { id: 24, name: 'Fabrics', label: 'Class 24' },
  { id: 25, name: 'Clothing', label: 'Class 25' },
  { id: 26, name: 'Fancy goods', label: 'Class 26' },
  { id: 27, name: 'Floor coverings', label: 'Class 27' },
  { id: 28, name: 'Toys and sporting goods', label: 'Class 28' },
  { id: 29, name: 'Meats and processed foods', label: 'Class 29' },
  { id: 30, name: 'Staple foods', label: 'Class 30' },
  { id: 31, name: 'Natural agricultural products', label: 'Class 31' },
  { id: 32, name: 'Light beverages', label: 'Class 32' },
  { id: 33, name: 'Wines and spirits', label: 'Class 33' },
  { id: 34, name: 'Smokers articles', label: 'Class 34' },
  { id: 35, name: 'Advertising and business', label: 'Class 35' },
];

// API Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

export default {
  USER_TYPES,
  USER_STATUS,
  SEARCH_TYPES,
  SEARCH_TYPE_LABELS,
  MATCH_TYPES,
  TRADEMARK_STATUS,
  REPORT_FORMATS,
  VIEW_TYPES,
  LINK_BEHAVIORS,
  SORT_ORDERS,
  SORT_FIELDS,
  FILE_TYPES,
  ALLOWED_EXTENSIONS,
  THEME_COLORS,
  ROUTES,
  STORAGE_KEYS,
  DEFAULTS,
  VALIDATION,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  COUNTRIES,
  TRADEMARK_CLASSES,
  HTTP_STATUS,
};